import { render, staticRenderFns } from "./InquiryDetailCommentReply.vue?vue&type=template&id=bc5cb78a&scoped=true&"
import script from "./InquiryDetailCommentReply.vue?vue&type=script&lang=js&"
export * from "./InquiryDetailCommentReply.vue?vue&type=script&lang=js&"
import style0 from "./InquiryDetailCommentReply.vue?vue&type=style&index=0&id=bc5cb78a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc5cb78a",
  null
  
)

export default component.exports